module.exports = __webpack_public_path__ + "static/img/news-20210712.2d86ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20210712.png
// module id = u7eB
// module chunks = 0